/**
 * Created by kmiltiadous on 31/07/2017.
 */
import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {TRAVEL_CREDIT_SERVICE_TOKEN} from '../services/travel-credit.service';
import {TravelCreditType} from '../models/travel-credit-type';


@Injectable()
export class TravelCreditTypeResolver implements Resolve<TravelCreditType> {

  private travelCreditTypes: Array<TravelCreditType> = null;

  constructor(@Inject(TRAVEL_CREDIT_SERVICE_TOKEN) private travelCreditService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TravelCreditType> {

    let self = this;
    return new Observable(observer => {
      if (!self.travelCreditTypes) {

        self.travelCreditService.getTravelCreditTypes().subscribe((data: Array<TravelCreditType>) => {
          self.travelCreditTypes = data;
          observer.next(this.getTravelCreditType(route));
          observer.complete();
        });
      } else {
        observer.next(this.getTravelCreditType(route));
        observer.complete();
      }
    });
  }

  getTravelCreditType(route: ActivatedRouteSnapshot): TravelCreditType {
    if (!route || !route.data || !route.data['travelCreditTypeId'] || !this.travelCreditTypes) {
      return null;
    }

    let travelCreditType = this.travelCreditTypes.find(t => t.id === route.data['travelCreditTypeId']);
    return travelCreditType;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/resolvers/travel-credit-type.resolver.ts